<template>
  <v-dialog v-model="dialog" max-width="500" persistent v-if="dialog">
    <v-card>
      <v-card-title class="headline">Agregar saldo</v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pt-5">
        <p> Introduce el monto de saldo para añadir a {{ user.name }}. </p>

        <v-chip-group column class="mb-4">
          <v-chip
              v-for="amount in amounts"
              :key="amount.value"
              @click="balance = amount.value"
              active-class="primary"
          >
            {{ amount.text }}
          </v-chip>
        </v-chip-group>

        <v-text-field
            v-model="balance"
            label="Otro monto"
            outlined
            dense
            type="number"
            prefix="$"
            :rules="[rules.min, rules.max]"
            min="0"
            max="10000"
        ></v-text-field>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <CancelButton @click="handleClose" :isLoading="isLoading"/>
        <CreateButton
            label="Agregar saldo"
            :isDisabled="!isValidAmount"
            :isLoading="isLoading"
            @click="openConfirmationDialog"
            icon="mdi-cash-plus"
        />
      </v-card-actions>
    </v-card>

    <DialogConfirmation
        :message="`¿Estás seguro de que deseas agregar $${balance} de saldo a ${user.name}? Su saldo final despues de la operación será de $${Number(user.balance) + Number(balance)}.`"
        @ok="handleAddBalance"
        ref="dialogConfirmation"
    />

  </v-dialog>
</template>

<script lang="ts">
import Vue from "vue";
import throwSuccessMessage from "@/utils/SuccessMessage";
import UserService from "@/services/users/UserService";
import DialogConfirmation from "@/components/DialogConfirmation.vue";
import {RequestChangeBalance} from "@/services/users/entities/RequestChangeBalance";
import CancelButton from "@/components/buttons/CancelButton.vue";
import CreateButton from "@/components/buttons/CreateButton.vue";

export default Vue.extend({
  name: "DialogAddBalance",
  components: {CreateButton, CancelButton, DialogConfirmation},
  props: {
    user: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      // Balance
      balance: null as number | null,
      amounts: [
        {value: 1000, text: "$1,000"},
        {value: 2000, text: "$2,000"},
        {value: 3000, text: "$3,000"},
        {value: 4000, text: "$4,000"},
        {value: 5000, text: "$5,000"},
        {value: 10000, text: "$10,000"},
      ] as { value: number; text: string }[],

      // Validation
      rules: {
        min: (v: number) => (v && v > -1) || "Monto inválido",
        max: (v: number) => (v && v <= 10000) || "El monto máximo es $10,000",
      },

      // Dialog
      dialog: false as boolean,
      isLoading: false as boolean,
    };
  },

  methods: {
    openConfirmationDialog() {
      (this.$refs.dialogConfirmation as any).dialog = true;
    },

    async handleAddBalance() {
      this.isLoading = true;
      if (!this.balance) return;
      try {
        const body: RequestChangeBalance = {
          username: this.user.username,
          amount: this.balance,
        }
        await UserService.addBalance(body);
        throwSuccessMessage("Saldo añadido correctamente");
        this.$emit("updateBalance");
      } finally {
        this.isLoading = false;
        this.handleClose();
      }
    },

    handleClose() {
      this.balance = 0;
      this.isLoading = false;
      this.dialog = false;
    },
  },

  computed: {
    isValidAmount(): boolean {
      if (!this.balance) return false;
      return this.balance > 0 && this.balance <= 10000;
    },
  },
});
</script>
